import { renderIsoCodeMappingField } from '@host/components/iso-code-mapping-input/IsoCodeMappingField'
import {
  GetGeneralCargoRoutingInfoFunc,
  IGateInFormDialogProps,
} from '@tom-ui/planning/pages/GateControl/Components/GateInDialog'
import {
  allocationsService,
  containerTurnoverService,
  generalCargoStockService,
} from '@tom-ui/storage'
import { useRoutingSlipMiniMap, useYardStores } from '@tom-ui/yard'
import { useEffect } from 'react'

export const useGateInBridge = (): IGateInFormDialogProps => {
  const { yardBlockStore } = useYardStores()
  const { loadStores, renderRouteMiniMap } = useRoutingSlipMiniMap()

  useEffect(() => {
    loadStores()
  }, [loadStores])

  const getEasiestContainerToReachFunc = async (containerIds?: number[], amount?: number) =>
    containerTurnoverService.getEasiestContainerToReach(containerIds, amount)

  const getJourneyPositions = async (
    journeyIds: number[],
    isForPlannedPosition?: boolean,
  ): Promise<{ journeyId: number; position: string }[]> => {
    const positions = await yardBlockStore.getBlockNamesByJourneyIds(
      journeyIds,
      isForPlannedPosition,
    )

    return positions.map(({ journeyId, position }: { journeyId: number; position: string }) => ({
      journeyId,
      position: position ?? '',
    }))
  }

  const getGeneralCargoRoutingInfo: GetGeneralCargoRoutingInfoFunc = async orders =>
    Promise.all(
      orders.map(async order => {
        const reservations = await generalCargoStockService.getPlannedOccupanciesByOrderId(order.id)
        const reservationLocations = reservations
          .map(r => `${r.generalCargoArea ?? ''} ${r.generalCargoLocation ?? ''}`.trim())
          .filter(Boolean)
        const location =
          reservationLocations.length > 0 ? [...new Set(reservationLocations)].join(', ') : ''

        return { orderId: order.id, location }
      }),
    )

  return {
    getEasiestContainerToReachFunc,
    validateAllocationSpace: allocationsService.validateAllocationCapacity,
    getJourneyPositions,
    getGeneralCargoRoutingInfo,
    renderRouteMiniMap,
    isoCodeMappingFieldRenderFn: renderIsoCodeMappingField,
  }
}
